/**
 * Textarea. Implements DESIGN.md §Components > Inputs / Fields, "Textarea": the light
 * input's shape (10px radius, surface fill, 1px border, 16px text, 16px side padding) at
 * a 120px minimum with 12px vertical padding, resizing vertically; the 2px focus-ring
 * outline offset 1px; a danger border when invalid. Reference: stars.css §5 `.textarea`.
 * 120px has no height step; the minimum is 128px (min-h-32).
 */
import React, { forwardRef } from 'react';
import { cn } from './cn';

export const Textarea = forwardRef(function Textarea({ invalid = false, className, ...props }, ref) {
  return (
    <textarea
      ref={ref}
      aria-invalid={invalid ? 'true' : props['aria-invalid']}
      className={cn(
        'tw-block tw-w-full tw-min-h-32 tw-resize-y tw-px-4 tw-py-3 tw-rounded-md tw-border tw-border-solid tw-bg-surface tw-text-text tw-text-md',
        'tw-border-border placeholder:tw-text-text-placeholder',
        'tw-transition-colors tw-duration-fast tw-ease-out',
        'focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-1 focus-visible:tw-outline-focus-ring',
        'disabled:tw-opacity-45 disabled:tw-cursor-not-allowed',
        invalid && 'tw-border-danger',
        className,
      )}
      {...props}
    />
  );
});
